import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ContentPlaceholder from 'components/ContentPlaceholder';

import { BodyRow, DateCell, RateCell } from './styles';

const PLACEHOLDER_BAR_STYLE = { width: '74px', height: '16px' };

const CurrencyYearArchiveRatesTablePlaceholder = memo(
  ({ rowCount, columnCount }) => (
    <tbody>
      {Array.from({ length: rowCount }, (_, index) => (
        <BodyRow key={index} $isEven={index % 2 === 1}>
          <DateCell>
            <ContentPlaceholder style={PLACEHOLDER_BAR_STYLE} />
          </DateCell>
          {Array.from({ length: columnCount - 1 }, (__, cellIndex) => (
            <RateCell key={cellIndex}>
              <ContentPlaceholder style={PLACEHOLDER_BAR_STYLE} />
            </RateCell>
          ))}
        </BodyRow>
      ))}
    </tbody>
  )
);

CurrencyYearArchiveRatesTablePlaceholder.propTypes = {
  rowCount: PropTypes.number,
  columnCount: PropTypes.number,
};

CurrencyYearArchiveRatesTablePlaceholder.defaultProps = {
  rowCount: 5,
  columnCount: 3,
};

export default CurrencyYearArchiveRatesTablePlaceholder;
